import TermsAcceptanceDialog from './TermsAcceptanceDialog';

export default TermsAcceptanceDialog;
